export const mobileMatchMedia = window.matchMedia('(max-width: 767px)');

// Intersection Observer API
export const IntersectionObserverOptions = {
  default: {
    root: null,
    rootMargin: '0px 0px -100% 0px',
    threshold: 0,
  },
  pcOptions: {
    root: null,
    rootMargin: '60px 0px -100% 0px',
    threshold: 0,
  },
  sliderOptions: {
    root: null,
    rootMargin: '-20% 0px',
    threshold: 0,
  },
};
